<script setup lang="ts">
import { faMinus, faPlus, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { GoogleMap, Marker } from 'vue3-google-map';

interface IProps {
    isLoading?: boolean;
    center: { lat: number; lng: number };
}

const { center, isLoading } = defineProps<IProps>();

const emit = defineEmits<{
    close: [];
}>();

const zoom = ref(16);

function increaseZoom() {
    if (zoom.value < 32) {
        zoom.value++;
    }
}

function decreaseZoom() {
    if (zoom.value > 1) {
        zoom.value--;
    }
}
</script>

<template>
    <div class="map-container">
        <section class="map-section-container">
            <GoogleMap
                class="google-map"
                :center
                :zoom="isLoading ? 6 : zoom"
                api-key="AIzaSyAGCWxWe1ElfwMJpvMw3n8Xbn0qr8Agsbk"
                :libraries="['places']"
                language="fa"
                :zoom-control="false"
                :map-type-control="false"
                :scale-control="false"
                :street-view-control="false"
                :rotate-control="false"
                :fullscreen-control="false"
                :disable-default-ui="false"
                gesture-handling="greedy"
                :clickable-icons="false"
            >
                <Marker :options="{ position: center }" />
            </GoogleMap>
            <mr-button
                class="close-fullscreen-button"
                :right-icon="faXmark"
                size="small"
                @click="emit('close')"
            >
                بستن تمام صفحه
            </mr-button>

            <div class="map-zoom">
                <mr-button
                    class="inc-zoom"
                    :icon-button="faPlus"
                    size="big"
                    @click="increaseZoom"
                />
                <mr-button
                    class="dec-zoom"
                    :icon-button="faMinus"
                    size="big"
                    @click="decreaseZoom"
                />
            </div>
        </section>
    </div>
</template>

<style lang="scss" scoped>
.map-container {
    position: fixed;
    inset: 0 0 0 0;
    z-index: 1000000000;
    background: white;
    .map-section-container {
        position: relative;
        flex: 1;
        border: 3px solid white;
        width: 100%;
        height: 100%;
        @include mobile-only {
            border-width: 0;
        }
        .google-map {
            width: 100%;
            height: 100%;
            overflow: hidden;
            border-radius: 12px;
            :deep(.gm-style) {
                font-feature-settings: 'ss02' !important;
            }
        }
        .close-fullscreen-button {
            position: absolute;
            top: 12px;
            right: 12px;
        }
        .map-zoom {
            position: absolute;
            bottom: 40px;
            right: 40px;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .dec-zoom {
                margin-top: 8px;
            }
        }
    }
}
</style>
